module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Meldinger"},"en":{"title":"Notifications"}}')
  delete Component.options._Ctor
}
